import React from 'react';
import Loader from '../Loader';
import styles from './styles.module.scss';

const Form = ({
  onSubmit,
  children,
  buttonText,
  closeText,
  closeFunction,
  extraClassName = '',
  extraStyleButton,
  onDragEnter,
  className = styles.container,
  disabled,
  id,
  loadingU,
  loadingStyle = styles.lds_ring,
  // width = 'w-[90%] top-[12px] left-[150%] absolute',
  // height = 'h-[100%]',
  width = 'w-[50%]',
  height = 'h-[100%]',
  extraButtonClass = 'nothing',
}) => {
  return (
    <form
      onSubmit={onSubmit}
      autoComplete="on"
      id={id}
      className={`${className} ${extraClassName}`}
      onDragEnter={onDragEnter}
    >
      {children}
      <div className={`${styles.formRoot} ${extraButtonClass} `}>
        {buttonText && (
          <button
            className={`${styles.submitItem} mainBgColor`}
            style={extraStyleButton}
            disabled={disabled}
          >
            {loadingU == true ? (
              <Loader
                className={'lds_ringWhite'}
                width={width}
                height={height}
              />
            ) : (
              <p className="relative">{buttonText}</p>
            )}
          </button>
        )}
        {closeText && (
          <button
            className={`${styles.closeItem}`}
            onClick={closeFunction}
            style={extraStyleButton}
            disabled={disabled}
          >
            {closeText}
          </button>
        )}
      </div>
    </form>
  );
};

export default Form;
